import { render, staticRenderFns } from "./client-board-sort.vue?vue&type=template&id=73c19d10"
import script from "./client-board-sort.vue?vue&type=script&lang=js"
export * from "./client-board-sort.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports